import { defaultProfile, type Profile } from './types.js';

const CURRENT_SCHEMA_VERSION = 1 as const;

/**
 * Bring an older profile blob up to the current schema. The ladder applies
 * each step in order; v1 is current so the ladder is empty, but the harness
 * exists for future schema changes.
 */
export function migrate(raw: unknown): Profile {
  if (!isPlainObject(raw)) return defaultProfile();
  const profile = raw as Record<string, unknown>;

  // v0 → v1: hypothetical future. Currently no-op; left as a marker.
  // if (profile.schemaVersion === 0) { profile = migrateV0toV1(profile); }

  if (profile.schemaVersion !== CURRENT_SCHEMA_VERSION) {
    return defaultProfile();
  }

  return validate(profile) ? (profile as unknown as Profile) : defaultProfile();
}

function isPlainObject(v: unknown): v is Record<string, unknown> {
  return typeof v === 'object' && v !== null && !Array.isArray(v);
}

function validate(p: Record<string, unknown>): boolean {
  if (typeof p.schemaVersion !== 'number') return false;
  if (p.locale !== null && p.locale !== 'nl' && p.locale !== 'en') return false;
  if (!isPlainObject(p.skills)) return false;
  if (!isPlainObject(p.history)) return false;
  for (const skill of ['recognition', 'counting', 'addition', 'subtraction'] as const) {
    const lvl = (p.skills as Record<string, unknown>)[skill];
    if (!isPlainObject(lvl)) return false;
    if (typeof (lvl as Record<string, unknown>).level !== 'number') return false;
    if (typeof (lvl as Record<string, unknown>).badSessionsAtLevel !== 'number') return false;
    if (!Array.isArray((p.history as Record<string, unknown>)[skill])) return false;
  }
  return true;
}
